
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.13230',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13230",
  "apollo-dlb": "static-3.86",
  "breeze-builder-lib": "static-1.784",
  "client-types": "static-1.496",
  "data-fetching-client": "static-1.9955",
  "foundations-components": "static-1-ech-accordiontransition-jank.35",
  "foundations-components-legacy": "static-1-ech-accordiontransition-jank.35",
  "foundations-theming": "static-1.4776",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.89",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8331",
  "hub-http-shared-msw-handlers": "static-1.10614",
  "hubspot-dlb": "static-2.1882",
  "hubspot-url-utils": "static-1.4297",
  "HubStyleTokens": "static-2.11790",
  "I18n": "static-7.1672",
  "jasmine-runner": "static-1.6751",
  "marketplace-discovery-studio-lib": "static-1.631",
  "marketplace-storefront-base": "static-1.13293",
  "quartz": "static-1.7455",
  "react-dlb": "static-1.88",
  "react-rhumb": "static-1.17020",
  "reactive-variable-buffer-atom": "static-1.3155",
  "reporting-testing-lib": "static-1.10742",
  "reselect": "static-3.12",
  "settings-ui-lib": "static-1.12825",
  "SharedI18nStrings": "static-1.183",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7625",
  "ui-addon-i18n": "static-1.11447",
  "ui-addon-react-router-dom": "static-1.9836",
  "unified-auth": "static-1.918",
  "unified-auth-core-lib": "static-1.1200",
  "usage-tracker": "static-1.7637",
  "usage-tracker-core": "static-1.7487",
  "customer-data-property-utils": "static-1.8401",
  "hub-http": "static-1.6512",
  "integrations-lib": "static-1.17024",
  "marketplace-ui-common": "static-1.20722",
  "marketplace-ui-install": "static-1.708",
  "property-management-iframe": "static-1.14133",
  "quartz-config": "static-1.1233",
  "quartz-core": "static-1.6674",
  "quartz-routing": "static-1.885",
  "quick-fetch": "static-1.4129",
  "react": "static-7.192",
  "rpc-client-utils": "static-1.4967",
  "ts-schema": "static-1.4293",
  "ui-universal-auth": "static-1.9404",
  "UIComponents": "static-3.8736",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.83",
  "metrics-js": "static-1.9867",
  "react-redux": "static-7.75",
  "redux": "static-4.76",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3619",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3732",
  "quartz-webpack": "static-1.3679",
  "bend-plugin-quartz-routing": "static-1.533",
  "ai-components-ui-library": "static-1.9711",
  "codemirror": "static-5.102",
  "foundations-assets": "static-1.5185",
  "pulse": "static-1.929",
  "react-codemirror": "static-1.10940",
  "ui-extensions-preview-lib": "static-1.604",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1-ech-accordiontransition-jank.35",
  "floating-ui": "static-1.63",
  "foundations-theming-specialty": "static-1.2492",
  "framer-motion": "static-1.79",
  "hs-story-utils": "static-1.9724",
  "react-aria": "static-1.72",
  "react-create-root-preference": "static-1.69",
  "react-select-plus": "static-1.113",
  "react-utils": "static-2.5556",
  "react-virtualized": "static-2.107",
  "StyleGuideUI": "static-3.501",
  "tanstack-table": "static-1.61",
  "trellis-assets": "static-1.2638",
  "ui-fonts": "static-1.1052",
  "ui-images": "static-2.1248",
  "bend-plugin-foundations-theming": "static-1.3259",
  "foundations-theming-base": "static-1.3761",
  "stylex": "static-1.41",
  "HeadJS": "static-2.796",
  "hs-test-utils-bend-plugin": "static-1.3442",
  "msw": "static-1.39",
  "testing-library": "static-1.158",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.229",
  "moment-timezone": "static-5.91",
  "jasmine": "static-4.4613",
  "ui-addon-video-player": "static-1.9003",
  "ai-rendering-library": "static-1.11096",
  "chirp-fetch": "static-1.2194",
  "connections-embed-lib": "static-1.1509",
  "copilot-toolkit": "static-1.11846",
  "feedback-loader": "static-1.29809",
  "laboratory-lib": "static-3.7452",
  "marketplace-embed": "static-1.22907",
  "marketplace-ui-details": "static-1.10617",
  "marketplace-ui-reviews": "static-1.20677",
  "marketplace-ui-tracking": "static-1.14892",
  "sanitize-text": "static-1.8454",
  "usage-tracker-multi": "static-1.6051",
  "usage-tracker-session-replay": "static-1.5323",
  "wootric-nps": "static-1.7199",
  "quartz-head": "static-1.1120",
  "web-vitals": "static-1.15",
  "apollo-link-hub-http": "static-2.4955",
  "immer": "static-1.101",
  "immerable": "static-1.4448",
  "highcharts": "static-8.111",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2685",
  "reporting-data": "static-1.68809",
  "cssUtils": "static-1.919",
  "flux-actions": "static-1.367",
  "react-colorpicker": "static-2.10518",
  "react-dnd-compat": "static-1.4917",
  "redux-observable": "static-1.75",
  "ReduxMessenger": "static-2.10670",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7627",
  "icons": "static-2.682",
  "marketplace-ui-apps-core": "static-1.19254",
  "storybook-react": "static-1.40",
  "trellis-story-utils": "static-1.4808",
  "foundations-components-test-utils": "static-1-ech-accordiontransition-jank.35",
  "quartz-i18n": "static-1.1130",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.452",
  "ads-unified-auth-lib": "static-1.1350",
  "generic-oauth-auth-lib": "static-1.46",
  "google-sheets-integration-lib": "static-1.1022",
  "microsoft-drive-auth-lib": "static-1.135",
  "surveymonkey-integration-lib": "static-1.479",
  "slack-ui-library": "static-1.10699",
  "fsm": "static-1.4049",
  "customer-data-objects": "static-1.7991",
  "property-translator": "static-1.5695",
  "hs-locale-management": "static-1.294",
  "frontend-preferences-client": "static-1.8223",
  "hs-promise-utils": "static-1.5895",
  "hubspot-apollo-client": "static-1.5177",
  "integrations-error-boundary-lib": "static-1.14439",
  "integrations-tracking-lib": "static-1.5907",
  "native-integrations-shared-strings": "static-1.8077",
  "sanitize": "static-1.4772",
  "superstore": "static-1.5057",
  "ui-shepherd-react": "static-3.10570",
  "ai-settings-ui-library": "static-1.8349",
  "hub-http-janus": "static-1.878",
  "hubspotter-http": "static-1.4863",
  "immutable-less": "static-1.4949",
  "marketplace-ui-client-types": "static-1.18129",
  "nav-meta": "static-1.30463",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18385",
  "ui-product-approvals-common": "static-1.1046",
  "ai-studio-lib": "static-1.12444",
  "hubspot-prosemirror": "static-1.18962",
  "integrations-reconnect-lib": "static-1.482",
  "ui-addon-iframeable": "static-1.9376",
  "ui-addon-integrations-directory-panel": "static-2.8326",
  "ui-product-approvals": "static-1.29151",
  "ui-tool-access": "static-1.10455",
  "inbound-db-properties-service-client": "static-1.4053",
  "property-management-common": "static-1.6421",
  "opentelemetry-fe-types": "static-1.71",
  "dispatcher": "static-1.143",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.575",
  "module-federation": "static-1.33",
  "opentelemetry-fe": "static-1.446",
  "quartz-auth": "static-1.1130",
  "quartz-test": "static-1.1130",
  "quartz-tracking": "static-1.834",
  "trellis-components": "static-1.2657",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.377",
  "HubStyle": "static-2.12097",
  "bender-build-tools": "static-1.3443",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.23013",
  "ContentUtils": "static-1.69120",
  "customer-data-objects-ui-components": "static-1.13330",
  "sassPrefix": "static-1.192",
  "diff-match-patch": "static-1.7",
  "bend-plugin-pulse": "static-1.432",
  "batch-promise": "static-1.1843",
  "event-emitter": "static-1.1253",
  "fast-json-patch": "static-1.70",
  "browser-eslint": "static-2.57",
  "magpie-lib": "static-1.5753",
  "magpie-types": "static-1.5213",
  "stylex-utils": "static-1.139",
  "trellis-theming": "static-1.1274",
  "avatar-components": "static-1.2780",
  "breeze-engine-core": "static-1.1006",
  "breeze-onboarding-components": "static-1.732",
  "customer-data-filters-ui": "static-1.40912",
  "customer-data-reference-ui-components": "static-1.13477",
  "embedded-academy-lib": "static-1.15508",
  "ExportDialog": "static-6.10678",
  "global-styles-ai-lib": "static-1.118",
  "highlight.js": "static-1.86",
  "marketplace-embed-ba": "static-1.610",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.42041",
  "reporting-snowflake": "static-1.57426",
  "reporting-ui-components": "static-2.66079",
  "reporting-visualizations": "static-1.60884",
  "trial-components-library": "static-1.14104",
  "ui-addon-teams": "static-1.21906",
  "upgrade-components-lib": "static-1.517",
  "navigation-components": "static-1.18826",
  "breeze-engine-lib": "static-1.1728",
  "simple-logging-lib": "static-1.3351",
  "fail-safe": "static-1.253",
  "app-governance-lib": "static-1.2383",
  "developer-experience-shared-components": "static-1.10830",
  "purchase-motions-components": "static-1.6362",
  "transmute": "static-2.97",
  "usage-based-billing-components-lib": "static-1.10248",
  "usage-tracker-anonymous": "static-1.6054",
  "usage-tracker-public": "static-1.7448",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3718",
  "persist-promise": "static-1.4000",
  "reference-resolvers": "static-1.8481",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "ui-extensibility-client-types": "static-1.4218",
  "hubspot-apollo-cache": "static-1.636",
  "universal-page-editor-lib": "static-1.3308",
  "final-form": "static-1.78",
  "redux-toolkit": "static-1.78",
  "simple-data-table": "static-1.3525",
  "atom": "static-1.5386",
  "merchandise-lib": "static-1.277",
  "salesImages": "static-1.562",
  "ui-addon-draggable": "static-3.5060",
  "content-assistance-lib": "static-1.8197",
  "content-media-capture": "static-1.5430",
  "customer-data-ui-utilities": "static-1.10129",
  "emoji-mart": "static-3.4",
  "file-manager-components": "static-1.24488",
  "growth-payments-core": "static-1.26173",
  "knowledge-content-types": "static-1.8643",
  "PatternValidationJS": "static-1.3193",
  "payment-link-components": "static-1.24164",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20303",
  "ui-addon-emoji-picker": "static-1.10186",
  "ui-business-units-lib": "static-1.9388",
  "video-components-external": "static-1.12143",
  "video-data-lib": "static-1.35801",
  "navigation-messaging": "static-1.8153",
  "collaboration-sidebar": "static-1.58712",
  "crm-component-utils": "static-1.39829",
  "crm-properties-common-lib": "static-1.6188",
  "customer-data-properties": "static-1.52583",
  "external-options-client-types": "static-1.4338",
  "framework-data-schema-resolvers": "static-1.7193",
  "property-value-citations": "static-1.3197",
  "reference-resolvers-lite": "static-1.8402",
  "opentelemetry-web": "static-1.13",
  "hubspotter-http-shared-msw-handlers": "static-1.10612",
  "base-ui": "static-1.22",
  "react-day-picker": "static-1.10",
  "tanstack-virtual": "static-1.38",
  "cms-field-types": "static-1.5114",
  "content-icons-ui": "static-1.2363",
  "idb-keyval": "static-1.51",
  "reactive-lib": "static-1.1018",
  "breeze-artifacts-sdk": "static-1.325",
  "onboarding-journeys-lib": "static-1.913",
  "onboarding-scopes": "static-1.6753",
  "conversations-skeleton-state": "static-1.7545",
  "crm-message-bus": "static-1.43750",
  "customer-data-filters-ui-msw-helpers": "static-1.23347",
  "events-data-lib": "static-1.544",
  "FormUrlGenerator": "static-2.5027",
  "framework-builder-read-service-client": "static-1.4219",
  "hs-resources": "static-1.492",
  "multi-account-reference-resolvers": "static-1.1305",
  "onboarding-tours": "static-1.17116",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14457",
  "academy-common-lib": "static-1.14968",
  "dashboard-lib": "static-1.82807",
  "getting-started-shared-tasks": "static-1.19232",
  "hubspot-prosemirror-plugins": "static-1.18954",
  "share-with-third-party-component-lib": "static-1.9007",
  "ui-asset-management-lib": "static-1.11398",
  "user-context": "static-1.5419",
  "reporting-plugins": "static-1.10750",
  "reporting-reports": "static-1.68486",
  "hubs-service-types": "static-1.1559",
  "purchase-motions-api": "static-1.6365",
  "signup-constants": "static-1.19625",
  "nest": "static-1.537",
  "breeze-engine-chat-components": "static-1.706",
  "ably": "static-2.2",
  "bend-plugin-fail-safe": "static-1.204",
  "framework-listing-lib": "static-2.29486",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31423",
  "apps-service-types": "static-1.4039",
  "oauth-service-types": "static-1.4538",
  "signup-ui-url-generator": "static-2.8361",
  "onboarding-tours-client": "static-1.5331",
  "one-click-checkout": "static-1.400",
  "platform-infra-nav-components": "static-1.7892",
  "subscription-experience-data-types": "static-1.15246",
  "crm-record-cards-service-types": "static-1.3786",
  "location-customization-utils-lib": "static-1.10089",
  "redux-thunk": "static-2.80",
  "react-flip-move": "static-1.78",
  "ui-coaching-tips": "static-1.29299",
  "content-media-composition-data-lib": "static-1.13234",
  "fix-webm-duration": "static-1.30",
  "notification-sounds": "static-1.4726",
  "react-immutable-render-mixin": "static-1.9",
  "seat-types-lib": "static-1.717",
  "ui-addon-opt": "static-4.8663",
  "commerce-tours-lib": "static-1.6613",
  "growth-onboarding-reliability": "static-1.5381",
  "sales-checkout-service-client": "static-1.3828",
  "data-token-picker": "static-1.16886",
  "FileManagerLib": "static-1.40128",
  "content-media-compositions": "static-2.17241",
  "media-bridge-lib": "static-1.19404",
  "chatspot-widget-iframe": "static-1.23004",
  "collaboration-sidebar-common": "static-1.3509",
  "marketing-platform-lib": "static-1.7170",
  "card-properties-lib": "static-1.45000",
  "commerce-subscription-lib": "static-1.37772",
  "crm-actions": "static-1.6653",
  "crm-cards-sdk": "static-1.44567",
  "customer-data-properties-shared-msw-handlers": "static-1.9941",
  "customer-data-tracking": "static-1.7182",
  "calling-global-api": "static-1.65611",
  "calling-internal-common": "static-1.31620",
  "calling-lifecycle-internal": "static-1.66993",
  "calling-lifecycle-messages": "static-1.59287",
  "commerce-products-lib": "static-1.10518",
  "conditional-properties-service-client": "static-1.4014",
  "crm-index-visualization-core": "static-1.4540",
  "crm-links": "static-1.6629",
  "crm-pipelines-api-client-types": "static-1.4347",
  "formula-editor": "static-1.14765",
  "google-libphonenumber": "static-1.45",
  "inbounddb-objects-service-types": "static-1.4426",
  "meetings-icalendar-utils-lib": "static-1.936",
  "multi-currency-client-types": "static-1.3909",
  "object-builder-ui-client": "static-1.49667",
  "pipeline-validation-client-types": "static-1.4181",
  "smart-data-capture-core": "static-1.136",
  "smart-property-lib": "static-1.8289",
  "tiered-pricing": "static-1.1950",
  "topics-actions-lib": "static-1.465",
  "ui-addon-form-validation": "static-1.11282",
  "zustand": "static-1.85",
  "fdsr-migration-layer": "static-1.312",
  "framework-data-schema-quick-fetch": "static-1.7098",
  "restore-request-side-panel-lib": "static-1.1671",
  "growth-data-modal": "static-1.5894",
  "growth-onboarding-confetti": "static-1.3361",
  "growth-onboarding-next-action-utils": "static-1.2680",
  "onboarding-tours-utils": "static-1.1183",
  "ui-shepherd-tracker": "static-1.7951",
  "academy-service-client": "static-1.3987",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39987",
  "SafeStorage": "static-1.4703",
  "video-embed": "static-1.36635",
  "redux-actions": "static-3.70",
  "EmailSignatureEditor": "static-1.24997",
  "viral-links-lib": "static-1.7376",
  "nested-table": "static-1.534",
  "timezone-utils": "static-2.5544",
  "getting-started-shared-tasks-store": "static-1.18350",
  "campaign-roi-lib": "static-1.10228",
  "campaigns-utils-lib": "static-1.3515",
  "ui-addon-calendars": "static-2.5632",
  "customer-data-views-management": "static-1.26017",
  "framework-data-table": "static-2.12546",
  "nudge-client-utils": "static-1.3150",
  "nudge-custom-ui-functions": "static-1.1491",
  "switchboard-lib": "static-1.516",
  "access-check-ui-lib": "static-1.1575",
  "app-users-service-client": "static-1.5918",
  "app-users-service-types": "static-1.5326",
  "mini-checkout-client": "static-1.27495",
  "onboarding-utils": "static-1.5668",
  "permissions-shared-i18n-strings-fe": "static-1.2120",
  "ui-coaching-tips-shared-config": "static-1.29284",
  "checkout-sdk": "static-3.24338",
  "payment-method-components": "static-1.7150",
  "touchless-buying-components": "static-1.6206",
  "upgrade-catalog-service-types": "static-1.3771",
  "edison-service-client-types": "static-1.693",
  "growth-onboarding-feedback-components": "static-1.6884",
  "audio-components": "static-1.6341",
  "FileManagerImages": "static-1.37639",
  "video-components": "static-1.14145",
  "js-cookie": "static-1.18",
  "crm_data": "static-4.92820",
  "customer-data-sidebar": "static-2.46730",
  "enrichment-lib": "static-1.353",
  "ui-addon-draggable-compat": "static-2.4564",
  "universal-record-utils-lib": "static-1.1928",
  "commerce-billing-lib": "static-1.20177",
  "commerce-shared-components-lib": "static-1.19217",
  "commerce-tools-ui-lib": "static-1.11039",
  "crm-fe-perf": "static-1.23202",
  "calling-error-reporting": "static-1.31627",
  "shared-worker-versioning": "static-1.11341",
  "calling-usage-tracker": "static-1.6836",
  "voice-sms-access-library": "static-1.2049",
  "commerce-permissions": "static-1.1077",
  "products-iframe-lib": "static-1.8585",
  "products-ui-components-shared-msw-handlers": "static-1.10996",
  "crm-index-associations-lib": "static-1.6741",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10697",
  "sales-views-client-types": "static-1.4557",
  "bark-lib": "static-1.16812",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.646",
  "policy-lib": "static-1.7101",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10760",
  "onboarding-data-sync-lib": "static-1.2509",
  "growth-onboarding-next-action-components": "static-1.2708",
  "user-context-client": "static-1.4806",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.61",
  "urlinator": "static-1.4832",
  "outpost": "static-1.4455",
  "draft-convert": "static-2.80",
  "draft-extend": "static-3.83",
  "draft-js": "static-5.85",
  "draft-plugins": "static-2.22154",
  "sales-email-signature-service-client": "static-1.4144",
  "ts-utils-lib": "static-1.449",
  "crm-export-dialog": "static-1.6583",
  "crm-index-ui-shimmer": "static-1.2627",
  "crm-view-components": "static-1.1147",
  "react-beautiful-dnd": "static-1.70",
  "customer-data-associations": "static-1.7626",
  "tasks-actions-lib": "static-1.120",
  "nudge-custom-function-registry": "static-1.2907",
  "nudge-renderer-utils": "static-1.3226",
  "whisper-core-api": "static-1.7316",
  "InboxConnectUtils": "static-4.15552",
  "emoji-regex": "static-1.7",
  "settings-content-modals": "static-1.46835",
  "hub-http-rxjs": "static-1.842",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4289",
  "company-details-components": "static-1.6502",
  "react-performance-metrics-lib": "static-1.855",
  "pricing-pages-ui-components": "static-1.15795",
  "quote-checkout-service-types": "static-1.3754",
  "social-insights-client-types": "static-1.22706",
  "crm_universal": "static-1.22495",
  "customer-data-email": "static-1.18524",
  "card-payment-highlight-lib": "static-1.37968",
  "commerce-contract-lib": "static-1.13312",
  "invoices-highlight-card-lib": "static-1.55737",
  "orders-highlight-card-lib": "static-1.22187",
  "products-highlight-card-lib": "static-1.18801",
  "quotes-highlight-card-lib": "static-1.72828",
  "crm-source-interpretation-lib": "static-1.5630",
  "data-agent-utils": "static-1.415",
  "crm-object-search-query-utilities": "static-1.10187",
  "utility-belt": "static-1.2832",
  "payments-enrollment-embed-lib": "static-1.23814",
  "stripe-embedded-components": "static-1.7995",
  "customer-data-rte": "static-1.33642",
  "cv-backend-services": "static-1.1597",
  "growth-onboarding-empty-states": "static-1.6272",
  "payments-post-enroll-local-storage-lib": "static-1.5406",
  "qrcode-generator": "static-1.76",
  "quotes-client-types": "static-1.38918",
  "calling-orchestration-schema": "static-1.36826",
  "react-reducer-toolkit": "static-1.16356",
  "meetings-connect-utils-lib": "static-1.7909",
  "hub-http-contrib": "static-1.3338",
  "ui-addon-sales-email": "static-1.5511",
  "access-control-lib": "static-1.10736",
  "EmailComponents": "static-1.55540",
  "EmailData": "static-1.54218",
  "redux-less": "static-2.9778",
  "company-details-service-types": "static-1.4239",
  "segments-query-core": "static-1.1723",
  "pricing-pages-api": "static-1.15660",
  "sequences-lib": "static-1.8529",
  "ui-gdpr-components": "static-1.10625",
  "products-ui-components": "static-1.41036",
  "accounting-integrations-ui-components": "static-1.7534",
  "invoices-ui-lib": "static-1.55753",
  "commerce-products-api": "static-1.2688",
  "invoices-iframe-lib": "static-1.57811",
  "quotes-modal-lib": "static-1.103506",
  "quotes-ui-lib": "static-1.81549",
  "stripe-connect-js": "static-1.76",
  "draft-content-plugins": "static-1.28900",
  "ContentComponents": "static-2.72076",
  "ContentData": "static-1.69195",
  "marketing-contacts-lib": "static-1.11019",
  "marketing-email-service-types": "static-1.2092",
  "messaging-editing-lib": "static-1.47133",
  "messaging-usage-based-billing-components-lib": "static-1.1995",
  "automation-ui-source-apps": "static-1.19680",
  "automation-ui-types": "static-1.20598",
  "messaging-types-lib": "static-1.46870",
  "onboarding-settings-client": "static-1.4808",
  "sequences-client-types-lib": "static-1.8386",
  "commerce-tax-lib": "static-1.839",
  "price-books-api": "static-1.1726",
  "price-books-components": "static-1.1784",
  "property-description-translator": "static-1.4138",
  "ramp-editor": "static-1.884",
  "commerce-analytics-service-client": "static-1.3816",
  "totals-ui-components": "static-1.24287",
  "SalesContentIndexUI": "static-3.9622",
  "advanced-menus-core": "static-1.15573",
  "advanced-menus-lib": "static-1.12448",
  "automation-ui-ubb": "static-1.6514",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7636",
  "data-token-views": "static-1.16867",
  "forms-utils-lib": "static-1.13091",
  "payments-embed-points-lib": "static-1.13586",
  "react-tinymce": "static-1.55973",
  "simple-menus-core": "static-1.15572",
  "simple-menus-lib": "static-1.17089",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.55099",
  "tinymce-data": "static-1.41184",
  "tinymce-plugins": "static-1.58213",
  "tinymce-themes": "static-1.57069",
  "ui-brand-identity-lib": "static-1.16466",
  "ui-memberships-settings-lib": "static-1.34836",
  "videoconference-integration-components": "static-1.7277",
  "marketing-contacts-client": "static-1.7810",
  "mc-hard-limits-client-types": "static-1.206",
  "automation-applications-service-types": "static-1.3652",
  "automation-platform-service-types": "static-1.2663",
  "ContentEditorUI": "static-2.77900",
  "content-whatsapp-service-types": "static-1.578",
  "short-messages-app-service-client": "static-1.4215",
  "web-interactives-components": "static-1.14245",
  "web-interactives-data": "static-1.14246",
  "messaging-shared-utils-lib": "static-1.1444",
  "messaging-user-info-utils-lib": "static-1.1614",
  "email-portal-health-service-types": "static-1.1279",
  "line-items-api": "static-1.1091",
  "commerce-totals-service-types": "static-1.4031",
  "FireAlarmUi": "static-1.4721",
  "sales-templates-service-types-lib": "static-1.4383",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22534",
  "automation-ui-usage-tracking": "static-1.21997",
  "data-studio-ubb": "static-1.3501",
  "interframe": "static-3.5055",
  "layout-dnd-components": "static-1.12964",
  "layout-dnd-utils": "static-1.11939",
  "NamespacedHubStyle": "static-2.9264",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27653",
  "content-management-data-lib": "static-1.5953",
  "copilot-plugins": "static-1.11818",
  "cta-picker": "static-1.37078",
  "customer-agent-discovery-components-lib": "static-1.3947",
  "editor-components": "static-1.13646",
  "editor-iframe-lib": "static-1.8795",
  "error-messaging-js": "static-1.5496",
  "FormsCommonComponents": "static-1.86551",
  "layout-data-lib": "static-1.10264",
  "pictos": "static-7.190",
  "react-transition-group": "static-2.73",
  "redux-request-state": "static-1.10950",
  "SharedLegalStrings": "static-1.2046",
  "smart-content-core": "static-1.43167",
  "smart-content-lib": "static-1.43820",
  "social-composer-lib": "static-1.60292",
  "structured-content-lib": "static-1.25910",
  "theme-previewer-lib": "static-1.53940",
  "tinymce-copilot": "static-1.17167",
  "xray-recommendation-lib": "static-1.8259",
  "automation-ui-routing": "static-1.21955",
  "sql-reporting-client-types": "static-1.5896",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42788",
  "reporting-enablement": "static-1.23826",
  "forms-ai-lib": "static-1.4760",
  "codemirror-dlb": "static-1.59459",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6738",
  "report-customization-components": "static-1.13908",
  "data-quality-ui-library": "static-1.13797",
  "reporting-filters": "static-1.1000",
  "reporting-insights-lib": "static-1.2561",
  "merge-modal-lib": "static-1.12553",
  "segments-client-types": "static-1.11522"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13230",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "breeze-builder-lib": "/breeze-builder-lib/static-1.784",
  "client-types": "/client-types/static-1.496",
  "data-fetching-client": "/data-fetching-client/static-1.9955",
  "foundations-components": "/foundations-components/static-1-ech-accordiontransition-jank.35",
  "foundations-components-legacy": "/foundations-components-legacy/static-1-ech-accordiontransition-jank.35",
  "foundations-theming": "/foundations-theming/static-1.4776",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.89",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8331",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10614",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "HubStyleTokens": "/HubStyleTokens/static-2.11790",
  "I18n": "/I18n/static-7.1672",
  "jasmine-runner": "/jasmine-runner/static-1.6751",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.631",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13293",
  "quartz": "/quartz/static-1.7455",
  "react-dlb": "/react-dlb/static-1.88",
  "react-rhumb": "/react-rhumb/static-1.17020",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3155",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10742",
  "reselect": "/reselect/static-3.12",
  "settings-ui-lib": "/settings-ui-lib/static-1.12825",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.183",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7625",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11447",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9836",
  "unified-auth": "/unified-auth/static-1.918",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1200",
  "usage-tracker": "/usage-tracker/static-1.7637",
  "usage-tracker-core": "/usage-tracker-core/static-1.7487",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8401",
  "hub-http": "/hub-http/static-1.6512",
  "integrations-lib": "/integrations-lib/static-1.17024",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20722",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.708",
  "property-management-iframe": "/property-management-iframe/static-1.14133",
  "quartz-config": "/quartz-config/static-1.1233",
  "quartz-core": "/quartz-core/static-1.6674",
  "quartz-routing": "/quartz-routing/static-1.885",
  "quick-fetch": "/quick-fetch/static-1.4129",
  "react": "/react/static-7.192",
  "rpc-client-utils": "/rpc-client-utils/static-1.4967",
  "ts-schema": "/ts-schema/static-1.4293",
  "ui-universal-auth": "/ui-universal-auth/static-1.9404",
  "UIComponents": "/UIComponents/static-3.8736",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.83",
  "metrics-js": "/metrics-js/static-1.9867",
  "react-redux": "/react-redux/static-7.75",
  "redux": "/redux/static-4.76",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3619",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3732",
  "quartz-webpack": "/quartz-webpack/static-1.3679",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.533",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9711",
  "codemirror": "/codemirror/static-5.102",
  "foundations-assets": "/foundations-assets/static-1.5185",
  "pulse": "/pulse/static-1.929",
  "react-codemirror": "/react-codemirror/static-1.10940",
  "ui-extensions-preview-lib": "/ui-extensions-preview-lib/static-1.604",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1-ech-accordiontransition-jank.35",
  "floating-ui": "/floating-ui/static-1.63",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2492",
  "framer-motion": "/framer-motion/static-1.79",
  "hs-story-utils": "/hs-story-utils/static-1.9724",
  "react-aria": "/react-aria/static-1.72",
  "react-create-root-preference": "/react-create-root-preference/static-1.69",
  "react-select-plus": "/react-select-plus/static-1.113",
  "react-utils": "/react-utils/static-2.5556",
  "react-virtualized": "/react-virtualized/static-2.107",
  "StyleGuideUI": "/StyleGuideUI/static-3.501",
  "tanstack-table": "/tanstack-table/static-1.61",
  "trellis-assets": "/trellis-assets/static-1.2638",
  "ui-fonts": "/ui-fonts/static-1.1052",
  "ui-images": "/ui-images/static-2.1248",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3259",
  "foundations-theming-base": "/foundations-theming-base/static-1.3761",
  "stylex": "/stylex/static-1.41",
  "HeadJS": "/HeadJS/static-2.796",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3442",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.158",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.229",
  "moment-timezone": "/moment-timezone/static-5.91",
  "jasmine": "/jasmine/static-4.4613",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9003",
  "ai-rendering-library": "/ai-rendering-library/static-1.11096",
  "chirp-fetch": "/chirp-fetch/static-1.2194",
  "connections-embed-lib": "/connections-embed-lib/static-1.1509",
  "copilot-toolkit": "/copilot-toolkit/static-1.11846",
  "feedback-loader": "/feedback-loader/static-1.29809",
  "laboratory-lib": "/laboratory-lib/static-3.7452",
  "marketplace-embed": "/marketplace-embed/static-1.22907",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10617",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20677",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14892",
  "sanitize-text": "/sanitize-text/static-1.8454",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6051",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5323",
  "wootric-nps": "/wootric-nps/static-1.7199",
  "quartz-head": "/quartz-head/static-1.1120",
  "web-vitals": "/web-vitals/static-1.15",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4955",
  "immer": "/immer/static-1.101",
  "immerable": "/immerable/static-1.4448",
  "highcharts": "/highcharts/static-8.111",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2685",
  "reporting-data": "/reporting-data/static-1.68809",
  "cssUtils": "/cssUtils/static-1.919",
  "flux-actions": "/flux-actions/static-1.367",
  "react-colorpicker": "/react-colorpicker/static-2.10518",
  "react-dnd-compat": "/react-dnd-compat/static-1.4917",
  "redux-observable": "/redux-observable/static-1.75",
  "ReduxMessenger": "/ReduxMessenger/static-2.10670",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7627",
  "icons": "/icons/static-2.682",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19254",
  "storybook-react": "/storybook-react/static-1.40",
  "trellis-story-utils": "/trellis-story-utils/static-1.4808",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1-ech-accordiontransition-jank.35",
  "quartz-i18n": "/quartz-i18n/static-1.1130",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.452",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1350",
  "generic-oauth-auth-lib": "/generic-oauth-auth-lib/static-1.46",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1022",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.135",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.479",
  "slack-ui-library": "/slack-ui-library/static-1.10699",
  "fsm": "/fsm/static-1.4049",
  "customer-data-objects": "/customer-data-objects/static-1.7991",
  "property-translator": "/property-translator/static-1.5695",
  "hs-locale-management": "/hs-locale-management/static-1.294",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8223",
  "hs-promise-utils": "/hs-promise-utils/static-1.5895",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5177",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14439",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5907",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8077",
  "sanitize": "/sanitize/static-1.4772",
  "superstore": "/superstore/static-1.5057",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10570",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8349",
  "hub-http-janus": "/hub-http-janus/static-1.878",
  "hubspotter-http": "/hubspotter-http/static-1.4863",
  "immutable-less": "/immutable-less/static-1.4949",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18129",
  "nav-meta": "/nav-meta/static-1.30463",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18385",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1046",
  "ai-studio-lib": "/ai-studio-lib/static-1.12444",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18962",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.482",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9376",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8326",
  "ui-product-approvals": "/ui-product-approvals/static-1.29151",
  "ui-tool-access": "/ui-tool-access/static-1.10455",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4053",
  "property-management-common": "/property-management-common/static-1.6421",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.71",
  "dispatcher": "/dispatcher/static-1.143",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.575",
  "module-federation": "/module-federation/static-1.33",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.446",
  "quartz-auth": "/quartz-auth/static-1.1130",
  "quartz-test": "/quartz-test/static-1.1130",
  "quartz-tracking": "/quartz-tracking/static-1.834",
  "trellis-components": "/trellis-components/static-1.2657",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.377",
  "HubStyle": "/HubStyle/static-2.12097",
  "bender-build-tools": "/bender-build-tools/static-1.3443",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.23013",
  "ContentUtils": "/ContentUtils/static-1.69120",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13330",
  "sassPrefix": "/sassPrefix/static-1.192",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.432",
  "batch-promise": "/batch-promise/static-1.1843",
  "event-emitter": "/event-emitter/static-1.1253",
  "fast-json-patch": "/fast-json-patch/static-1.70",
  "browser-eslint": "/browser-eslint/static-2.57",
  "magpie-lib": "/magpie-lib/static-1.5753",
  "magpie-types": "/magpie-types/static-1.5213",
  "stylex-utils": "/stylex-utils/static-1.139",
  "trellis-theming": "/trellis-theming/static-1.1274",
  "avatar-components": "/avatar-components/static-1.2780",
  "breeze-engine-core": "/breeze-engine-core/static-1.1006",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.732",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40912",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13477",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15508",
  "ExportDialog": "/ExportDialog/static-6.10678",
  "global-styles-ai-lib": "/global-styles-ai-lib/static-1.118",
  "highlight.js": "/highlight.js/static-1.86",
  "marketplace-embed-ba": "/marketplace-embed-ba/static-1.610",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.42041",
  "reporting-snowflake": "/reporting-snowflake/static-1.57426",
  "reporting-ui-components": "/reporting-ui-components/static-2.66079",
  "reporting-visualizations": "/reporting-visualizations/static-1.60884",
  "trial-components-library": "/trial-components-library/static-1.14104",
  "ui-addon-teams": "/ui-addon-teams/static-1.21906",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.517",
  "navigation-components": "/navigation-components/static-1.18826",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1728",
  "simple-logging-lib": "/simple-logging-lib/static-1.3351",
  "fail-safe": "/fail-safe/static-1.253",
  "app-governance-lib": "/app-governance-lib/static-1.2383",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10830",
  "purchase-motions-components": "/purchase-motions-components/static-1.6362",
  "transmute": "/transmute/static-2.97",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10248",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6054",
  "usage-tracker-public": "/usage-tracker-public/static-1.7448",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "persist-promise": "/persist-promise/static-1.4000",
  "reference-resolvers": "/reference-resolvers/static-1.8481",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4218",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.636",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3308",
  "final-form": "/final-form/static-1.78",
  "redux-toolkit": "/redux-toolkit/static-1.78",
  "simple-data-table": "/simple-data-table/static-1.3525",
  "atom": "/atom/static-1.5386",
  "merchandise-lib": "/merchandise-lib/static-1.277",
  "salesImages": "/salesImages/static-1.562",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5060",
  "content-assistance-lib": "/content-assistance-lib/static-1.8197",
  "content-media-capture": "/content-media-capture/static-1.5430",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10129",
  "emoji-mart": "/emoji-mart/static-3.4",
  "file-manager-components": "/file-manager-components/static-1.24488",
  "growth-payments-core": "/growth-payments-core/static-1.26173",
  "knowledge-content-types": "/knowledge-content-types/static-1.8643",
  "PatternValidationJS": "/PatternValidationJS/static-1.3193",
  "payment-link-components": "/payment-link-components/static-1.24164",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20303",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10186",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9388",
  "video-components-external": "/video-components-external/static-1.12143",
  "video-data-lib": "/video-data-lib/static-1.35801",
  "navigation-messaging": "/navigation-messaging/static-1.8153",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58712",
  "crm-component-utils": "/crm-component-utils/static-1.39829",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6188",
  "customer-data-properties": "/customer-data-properties/static-1.52583",
  "external-options-client-types": "/external-options-client-types/static-1.4338",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7193",
  "property-value-citations": "/property-value-citations/static-1.3197",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8402",
  "opentelemetry-web": "/opentelemetry-web/static-1.13",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10612",
  "base-ui": "/base-ui/static-1.22",
  "react-day-picker": "/react-day-picker/static-1.10",
  "tanstack-virtual": "/tanstack-virtual/static-1.38",
  "cms-field-types": "/cms-field-types/static-1.5114",
  "content-icons-ui": "/content-icons-ui/static-1.2363",
  "idb-keyval": "/idb-keyval/static-1.51",
  "reactive-lib": "/reactive-lib/static-1.1018",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.325",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.913",
  "onboarding-scopes": "/onboarding-scopes/static-1.6753",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7545",
  "crm-message-bus": "/crm-message-bus/static-1.43750",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23347",
  "events-data-lib": "/events-data-lib/static-1.544",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5027",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4219",
  "hs-resources": "/hs-resources/static-1.492",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1305",
  "onboarding-tours": "/onboarding-tours/static-1.17116",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14457",
  "academy-common-lib": "/academy-common-lib/static-1.14968",
  "dashboard-lib": "/dashboard-lib/static-1.82807",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19232",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18954",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.9007",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11398",
  "user-context": "/user-context/static-1.5419",
  "reporting-plugins": "/reporting-plugins/static-1.10750",
  "reporting-reports": "/reporting-reports/static-1.68486",
  "hubs-service-types": "/hubs-service-types/static-1.1559",
  "purchase-motions-api": "/purchase-motions-api/static-1.6365",
  "signup-constants": "/signup-constants/static-1.19625",
  "nest": "/nest/static-1.537",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.706",
  "ably": "/ably/static-2.2",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.204",
  "framework-listing-lib": "/framework-listing-lib/static-2.29486",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31423",
  "apps-service-types": "/apps-service-types/static-1.4039",
  "oauth-service-types": "/oauth-service-types/static-1.4538",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8361",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5331",
  "one-click-checkout": "/one-click-checkout/static-1.400",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7892",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15246",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3786",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10089",
  "redux-thunk": "/redux-thunk/static-2.80",
  "react-flip-move": "/react-flip-move/static-1.78",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29299",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13234",
  "fix-webm-duration": "/fix-webm-duration/static-1.30",
  "notification-sounds": "/notification-sounds/static-1.4726",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "seat-types-lib": "/seat-types-lib/static-1.717",
  "ui-addon-opt": "/ui-addon-opt/static-4.8663",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6613",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5381",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3828",
  "data-token-picker": "/data-token-picker/static-1.16886",
  "FileManagerLib": "/FileManagerLib/static-1.40128",
  "content-media-compositions": "/content-media-compositions/static-2.17241",
  "media-bridge-lib": "/media-bridge-lib/static-1.19404",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.23004",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3509",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7170",
  "card-properties-lib": "/card-properties-lib/static-1.45000",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37772",
  "crm-actions": "/crm-actions/static-1.6653",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44567",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9941",
  "customer-data-tracking": "/customer-data-tracking/static-1.7182",
  "calling-global-api": "/calling-global-api/static-1.65611",
  "calling-internal-common": "/calling-internal-common/static-1.31620",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66993",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59287",
  "commerce-products-lib": "/commerce-products-lib/static-1.10518",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4014",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4540",
  "crm-links": "/crm-links/static-1.6629",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4347",
  "formula-editor": "/formula-editor/static-1.14765",
  "google-libphonenumber": "/google-libphonenumber/static-1.45",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4426",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.936",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3909",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49667",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4181",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.136",
  "smart-property-lib": "/smart-property-lib/static-1.8289",
  "tiered-pricing": "/tiered-pricing/static-1.1950",
  "topics-actions-lib": "/topics-actions-lib/static-1.465",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11282",
  "zustand": "/zustand/static-1.85",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.312",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7098",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1671",
  "growth-data-modal": "/growth-data-modal/static-1.5894",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3361",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2680",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1183",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7951",
  "academy-service-client": "/academy-service-client/static-1.3987",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39987",
  "SafeStorage": "/SafeStorage/static-1.4703",
  "video-embed": "/video-embed/static-1.36635",
  "redux-actions": "/redux-actions/static-3.70",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24997",
  "viral-links-lib": "/viral-links-lib/static-1.7376",
  "nested-table": "/nested-table/static-1.534",
  "timezone-utils": "/timezone-utils/static-2.5544",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18350",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10228",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3515",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5632",
  "customer-data-views-management": "/customer-data-views-management/static-1.26017",
  "framework-data-table": "/framework-data-table/static-2.12546",
  "nudge-client-utils": "/nudge-client-utils/static-1.3150",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1491",
  "switchboard-lib": "/switchboard-lib/static-1.516",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1575",
  "app-users-service-client": "/app-users-service-client/static-1.5918",
  "app-users-service-types": "/app-users-service-types/static-1.5326",
  "mini-checkout-client": "/mini-checkout-client/static-1.27495",
  "onboarding-utils": "/onboarding-utils/static-1.5668",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2120",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29284",
  "checkout-sdk": "/checkout-sdk/static-3.24338",
  "payment-method-components": "/payment-method-components/static-1.7150",
  "touchless-buying-components": "/touchless-buying-components/static-1.6206",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3771",
  "edison-service-client-types": "/edison-service-client-types/static-1.693",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6884",
  "audio-components": "/audio-components/static-1.6341",
  "FileManagerImages": "/FileManagerImages/static-1.37639",
  "video-components": "/video-components/static-1.14145",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_data": "/crm_data/static-4.92820",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46730",
  "enrichment-lib": "/enrichment-lib/static-1.353",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4564",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1928",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20177",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19217",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11039",
  "crm-fe-perf": "/crm-fe-perf/static-1.23202",
  "calling-error-reporting": "/calling-error-reporting/static-1.31627",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11341",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6836",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2049",
  "commerce-permissions": "/commerce-permissions/static-1.1077",
  "products-iframe-lib": "/products-iframe-lib/static-1.8585",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10996",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6741",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10697",
  "sales-views-client-types": "/sales-views-client-types/static-1.4557",
  "bark-lib": "/bark-lib/static-1.16812",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.646",
  "policy-lib": "/policy-lib/static-1.7101",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10760",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2509",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2708",
  "user-context-client": "/user-context-client/static-1.4806",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.61",
  "urlinator": "/urlinator/static-1.4832",
  "outpost": "/outpost/static-1.4455",
  "draft-convert": "/draft-convert/static-2.80",
  "draft-extend": "/draft-extend/static-3.83",
  "draft-js": "/draft-js/static-5.85",
  "draft-plugins": "/draft-plugins/static-2.22154",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4144",
  "ts-utils-lib": "/ts-utils-lib/static-1.449",
  "crm-export-dialog": "/crm-export-dialog/static-1.6583",
  "crm-index-ui-shimmer": "/crm-index-ui-shimmer/static-1.2627",
  "crm-view-components": "/crm-view-components/static-1.1147",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.70",
  "customer-data-associations": "/customer-data-associations/static-1.7626",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.120",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2907",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3226",
  "whisper-core-api": "/whisper-core-api/static-1.7316",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15552",
  "emoji-regex": "/emoji-regex/static-1.7",
  "settings-content-modals": "/settings-content-modals/static-1.46835",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.842",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4289",
  "company-details-components": "/company-details-components/static-1.6502",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.855",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.15795",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3754",
  "social-insights-client-types": "/social-insights-client-types/static-1.22706",
  "crm_universal": "/crm_universal/static-1.22495",
  "customer-data-email": "/customer-data-email/static-1.18524",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37968",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.13312",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55737",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22187",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18801",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72828",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5630",
  "data-agent-utils": "/data-agent-utils/static-1.415",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10187",
  "utility-belt": "/utility-belt/static-1.2832",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23814",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7995",
  "customer-data-rte": "/customer-data-rte/static-1.33642",
  "cv-backend-services": "/cv-backend-services/static-1.1597",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6272",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5406",
  "qrcode-generator": "/qrcode-generator/static-1.76",
  "quotes-client-types": "/quotes-client-types/static-1.38918",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36826",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16356",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7909",
  "hub-http-contrib": "/hub-http-contrib/static-1.3338",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5511",
  "access-control-lib": "/access-control-lib/static-1.10736",
  "EmailComponents": "/EmailComponents/static-1.55540",
  "EmailData": "/EmailData/static-1.54218",
  "redux-less": "/redux-less/static-2.9778",
  "company-details-service-types": "/company-details-service-types/static-1.4239",
  "segments-query-core": "/segments-query-core/static-1.1723",
  "pricing-pages-api": "/pricing-pages-api/static-1.15660",
  "sequences-lib": "/sequences-lib/static-1.8529",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10625",
  "products-ui-components": "/products-ui-components/static-1.41036",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7534",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55753",
  "commerce-products-api": "/commerce-products-api/static-1.2688",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57811",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103506",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81549",
  "stripe-connect-js": "/stripe-connect-js/static-1.76",
  "draft-content-plugins": "/draft-content-plugins/static-1.28900",
  "ContentComponents": "/ContentComponents/static-2.72076",
  "ContentData": "/ContentData/static-1.69195",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.11019",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2092",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.47133",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1995",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19680",
  "automation-ui-types": "/automation-ui-types/static-1.20598",
  "messaging-types-lib": "/messaging-types-lib/static-1.46870",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4808",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8386",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.839",
  "price-books-api": "/price-books-api/static-1.1726",
  "price-books-components": "/price-books-components/static-1.1784",
  "property-description-translator": "/property-description-translator/static-1.4138",
  "ramp-editor": "/ramp-editor/static-1.884",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3816",
  "totals-ui-components": "/totals-ui-components/static-1.24287",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9622",
  "advanced-menus-core": "/advanced-menus-core/static-1.15573",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12448",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6514",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7636",
  "data-token-views": "/data-token-views/static-1.16867",
  "forms-utils-lib": "/forms-utils-lib/static-1.13091",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13586",
  "react-tinymce": "/react-tinymce/static-1.55973",
  "simple-menus-core": "/simple-menus-core/static-1.15572",
  "simple-menus-lib": "/simple-menus-lib/static-1.17089",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.55099",
  "tinymce-data": "/tinymce-data/static-1.41184",
  "tinymce-plugins": "/tinymce-plugins/static-1.58213",
  "tinymce-themes": "/tinymce-themes/static-1.57069",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16466",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34836",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7277",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7810",
  "mc-hard-limits-client-types": "/mc-hard-limits-client-types/static-1.206",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3652",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2663",
  "ContentEditorUI": "/ContentEditorUI/static-2.77900",
  "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.578",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4215",
  "web-interactives-components": "/web-interactives-components/static-1.14245",
  "web-interactives-data": "/web-interactives-data/static-1.14246",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1444",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1614",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1279",
  "line-items-api": "/line-items-api/static-1.1091",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.4031",
  "FireAlarmUi": "/FireAlarmUi/static-1.4721",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4383",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22534",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21997",
  "data-studio-ubb": "/data-studio-ubb/static-1.3501",
  "interframe": "/interframe/static-3.5055",
  "layout-dnd-components": "/layout-dnd-components/static-1.12964",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11939",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9264",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27653",
  "content-management-data-lib": "/content-management-data-lib/static-1.5953",
  "copilot-plugins": "/copilot-plugins/static-1.11818",
  "cta-picker": "/cta-picker/static-1.37078",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3947",
  "editor-components": "/editor-components/static-1.13646",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8795",
  "error-messaging-js": "/error-messaging-js/static-1.5496",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86551",
  "layout-data-lib": "/layout-data-lib/static-1.10264",
  "pictos": "/pictos/static-7.190",
  "react-transition-group": "/react-transition-group/static-2.73",
  "redux-request-state": "/redux-request-state/static-1.10950",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2046",
  "smart-content-core": "/smart-content-core/static-1.43167",
  "smart-content-lib": "/smart-content-lib/static-1.43820",
  "social-composer-lib": "/social-composer-lib/static-1.60292",
  "structured-content-lib": "/structured-content-lib/static-1.25910",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53940",
  "tinymce-copilot": "/tinymce-copilot/static-1.17167",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8259",
  "automation-ui-routing": "/automation-ui-routing/static-1.21955",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5896",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42788",
  "reporting-enablement": "/reporting-enablement/static-1.23826",
  "forms-ai-lib": "/forms-ai-lib/static-1.4760",
  "codemirror-dlb": "/codemirror-dlb/static-1.59459",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6738",
  "report-customization-components": "/report-customization-components/static-1.13908",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13797",
  "reporting-filters": "/reporting-filters/static-1.1000",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2561",
  "merge-modal-lib": "/merge-modal-lib/static-1.12553",
  "segments-client-types": "/segments-client-types/static-1.11522"
}
};
